import moment from 'moment';
export default function ($rootScope, $scope, $http, $cookies, $timeout, $window, $uibModalInstance, CONFIG, UtilitiesFactory, value) {
    'ngInject';

    moment.locale('de');

    let paginationResultsPerPage = CONFIG.paginationResultsPerPageModal;
    let regionId = !!$cookies.get('region') ? JSON.parse($cookies.get('region')).sys.id : null;

    $scope.isProgress = false;
    $scope.type = 'ex';
    $scope.items = [];
    $scope.selection = [];
    $scope.page = 1;
    $scope.link = { url: ''};

    $scope.isLink = true;
    $scope.isArticle = false;
    $scope.isFile =  false;

    console.log('value', value);

    let id = null;
    if (!!value) {
        let values = value.split('/');
        id = _.last(values);
        let type = values[values.length - 2];

        $scope.isLink = false;
        $scope.isArticle = false;
        $scope.isFile =  false;

        if (type === 'article') {
            $scope.type = 'in_art';
            $scope.isArticle = true;
        } else if (type === 'asset') {
            $scope.type = 'in_fil';
            $scope.isFile =  true;
        } else {
            $scope.type = 'ex';
            $scope.isLink = true;
            $scope.link.url = value;
        }
    }

    /***
     * Load Articles
     */
    let loadArticles = () => {
        $scope.isProgress = true;
        let endpoint = `entries?content_type=article&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
        endpoint += `&fields.region.sys.id=${regionId}`;
        endpoint += `&skip=${CONFIG.paginationResultsPerPageModal * ($scope.page - 1)}&limit=${CONFIG.paginationResultsPerPageModal}`;

        $http.get(`${CONFIG.customUploadUrl}contentful/` + endpoint).then((data) => {
            $scope.items = data.data.items;
            $scope.page = 1;
            $scope.pagesTotal = Math.round(data.data.total / paginationResultsPerPage);
            $scope.paginationRange = UtilitiesFactory.paginationRange($scope.page, CONFIG.paginationLinksOffset, $scope.pagesTotal);

            _.forEach($scope.items, (item) => {
                item.sys.createdAt = moment(item.sys.createdAt).format("DD. MMMM YYYY");
            });

            $scope.isProgress = false;
        });
    };


    /***
     * Load Files
     */
    let loadFiles = () => {
        $scope.isProgress = true;
        let endpoint = `assets?sys.type[ne]=${(new Date()).valueOf()}&order=-sys.updatedAt`;
        endpoint += `&skip=${CONFIG.paginationResultsPerPageModal * ($scope.page - 1)}&limit=${CONFIG.paginationResultsPerPageModal}`;

        $http.get(`${CONFIG.customUploadUrl}contentful/` + endpoint).then((data) => {
            $scope.items = data.data.items;

            _.forEach($scope.items, (item) => {
                item.isImage = false;
                console.log(item.fields.file.url, item.fields.file.url.toLowerCase().indexOf('.png'), item.fields.file.url.toLowerCase().indexOf('.jpg'));
                if (item.fields.file.url.toLowerCase().indexOf('.png') > -1 || item.fields.file.url.toLowerCase().indexOf('.jpg') > -1) {
                    item.isImage = true;
                }
            });

            $scope.page = 1;
            $scope.pagesTotal = Math.floor(data.data.total / paginationResultsPerPage);
            $scope.paginationRange = UtilitiesFactory.paginationRange($scope.page, CONFIG.paginationLinksOffset, $scope.pagesTotal);

            $scope.isProgress = false;
        });
    };


    /***
     * Change View
     * @param type
     */
    $scope.changeView = (type) => {
        $scope.page = 1;
        if (type === 'ex') {
            $scope.type = 'ex';
        }

        if (type === 'in_art') {
            $scope.type = 'in_art';
            loadArticles();
        }

        if (type === 'in_fil') {
            $scope.type = 'in_fil';
            loadFiles();
        }
    };

    /***
     * Change Page
     * @param page
     */
    $scope.changePage = (page) => {
        $scope.isProgress = true;
        $scope.items = [];
        let endpoint = '';
        if ($scope.type === 'in_fil') {
            endpoint = `assets?&sys.type[ne]=${(new Date()).valueOf()}&order=-sys.createdAt`;
        } else {
            endpoint = `entries?content_type=article&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
        }
        endpoint += `&skip=${ paginationResultsPerPage * (page - 1) }&limit=${ paginationResultsPerPage }`;

        $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
            $scope.page = page;
            $scope.items = data.data.items;

            if ($scope.type === 'in_fil') {
                _.forEach($scope.items, (item) => {
                    item.isImage = false;
                    console.log(item.fields.file.url, item.fields.file.url.toLowerCase().indexOf('.png'), item.fields.file.url.toLowerCase().indexOf('.jpg'));
                    if (item.fields.file.url.toLowerCase().indexOf('.png') > -1 || item.fields.file.url.toLowerCase().indexOf('.jpg') > -1) {
                        item.isImage = true;
                    }
                });
            }

            _.forEach($scope.items, (item) => {
                item.sys.createdAt = moment(item.sys.createdAt).format("DD. MMMM YYYY");
            });

            $scope.paginationRange = UtilitiesFactory.paginationRange($scope.page, CONFIG.paginationLinksOffset, $scope.pagesTotal);
            $scope.isProgress = false;

            console.log($scope.page, $scope.pagesTotal, $scope.paginationRange);
        });
    };


    /***
     * Toggle Selection
     * @param item
     */
    $scope.toggleSelection = (item) => {
        let idx =  _.filter($scope.selection, (selection) => { return selection.sys.id === item.sys.id});
        if (idx.length > 0) {
            $scope.selection = _.filter($scope.selection, (selection) => { return selection.sys.id !== item.sys.id});
        } else {
            $scope.selection = [];
            $scope.selection.push(item);
        }
    };

    /***
     * Check if asset is checked
     * @param asset
     * @returns {boolean}
     */
    $scope.checkIfAssetCheched = (asset) => {
        let array = _.filter($scope.selection, (selection) => { return selection.sys.id === asset.sys.id });
        return array.length > 0;
    };


    /***
     * Submit
     */
    $scope.submit = () => {
        $uibModalInstance.close({item: $scope.selection, type: $scope.type, link: $scope.link.url});
    };

    /***
     * Search Engine
     * @param word
     * @param keyCode
     */
    $scope.changed = (word, keyCode) => {
        let endpoint = '';
        if ($scope.type === 'in_fil') {
            endpoint = `assets?&query=${word}&sys.type[ne]=${(new Date()).valueOf()}&order=-sys.createdAt`;
        } else {
            endpoint = `entries?content_type=article&query=${word}&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
        }

        if (keyCode === 13 || word === '') {
            $scope.isProgress = true;
            $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
                $scope.page = 1;
                $scope.items = data.data.items;
                $scope.pagesTotal = Math.floor(data.data.total / paginationResultsPerPage);
                $scope.paginationRange = UtilitiesFactory.paginationRange($scope.page, CONFIG.paginationLinksOffset, $scope.pagesTotal);

                $timeout(function() {
                    let search_element = $window.document.getElementById("search");
                    search_element.focus();
                });

                $scope.isProgress = false;
            });
        }
    };


    $scope.changeView($scope.type);
}



// WEBPACK FOOTER //
// ./src/app/views/app.modal/linkOptionsModalCtrl.js